var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimeline = function SvgTimeline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5229 2.25V13.5H21.7729C21.7729 7.2868 16.7362 2.25 10.5229 2.25Z",
    fill: "#DAD8FF",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 1,
    fill: "#4239FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 1,
    fill: "#4239FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 1,
    fill: "#4239FB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 22.5,
    r: 1,
    fill: "#4239FB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 1,
    fill: "#4239FB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 13.5,
    r: 1,
    fill: "#4239FB"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeline);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC41MjI5IDIuMjVWMTMuNUgyMS43NzI5QzIxLjc3MjkgNy4yODY4IDE2LjczNjIgMi4yNSAxMC41MjI5IDIuMjVaIiBmaWxsPSIjREFEOEZGIiBzdHJva2U9IiM0MjM5RkIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGNpcmNsZSBjeD0iNSIgY3k9IjgiIHI9IjEiIGZpbGw9IiM0MjM5RkIiLz4KPGNpcmNsZSBjeD0iMTYiIGN5PSI4IiByPSIxIiBmaWxsPSIjNDIzOUZCIi8+CjxjaXJjbGUgY3g9IjE2IiBjeT0iMTkiIHI9IjEiIGZpbGw9IiM0MjM5RkIiLz4KPGNpcmNsZSBjeD0iMTAuNSIgY3k9IjIyLjUiIHI9IjEiIGZpbGw9IiM0MjM5RkIiLz4KPGNpcmNsZSBjeD0iNSIgY3k9IjE5IiByPSIxIiBmaWxsPSIjNDIzOUZCIi8+CjxjaXJjbGUgY3g9IjMiIGN5PSIxMy41IiByPSIxIiBmaWxsPSIjNDIzOUZCIi8+Cjwvc3ZnPgo=";